import { ReactElement } from 'react'
import { DashboardCountProps } from './typings'
import { Card, CardBody } from './subcomponents'

const DashboardCount = ({
  title,
  subtitle,
  color
}: DashboardCountProps): ReactElement => {
  return (
    <Card color={color}>
      <CardBody>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{subtitle}</Card.Text>
      </CardBody>
    </Card>
  )
}

export default DashboardCount
